import { formatNumber } from "_common/utils/formatValue";
import classNames from "classnames";
import React, { useEffect, useState } from "react";

function InputNumber({ onChangeText, value: valueInput, ...props }) {
  const inputRef = React.useRef(null);

  const [value, setValue] = useState();

  useEffect(() => {
    setValue(valueInput);
  }, [valueInput]);

  const handleChangeInput = (e) => {
    let val = e?.target?.value;
    val = val?.replace(/[^0-9]/g,'');
    setValue(val);
    onChangeText?.(val);
  };

  return (
    <div className="control-wrapper">
      <input 
        type="hidden"
        {...props} 
      />
      <input 
        ref={inputRef}
        type="text"
        inputMode="decimal"
        value={value ? formatNumber(value): ""}
        onKeyUp={props?.onKeyUp}
        className={classNames("zz_input", props?.className)}
        placeholder={props?.placeholder}
        onChange={(e) => handleChangeInput(e)}
       />
    </div>
  );
}

export default InputNumber;
